import { useEffect, useState } from "react";
import { GetNewmultiTimeZone } from "../services/multiTimeZoneService";

export const useTimezone = () => {
  const [timezone, setTimezone] = useState([]);

  useEffect(() => {
    getTimeZoneList()
  }, []);

  const getTimeZoneList = () => {
    try {
      let obj = {
        type: "TimeZone",
      };
      GetNewmultiTimeZone(obj).then((resp) => {
        if (resp != undefined) {
          console.log("getTimeZoneList", resp)
          if (resp.Status == "success") {
            setTimezone(resp.Data);
          } else {
            setTimezone(null);
          }
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  return { timezone }
}